export default __webpack_public_path__ + "static/media/gatia_space_view.517a8295.jpg";